<template>
  <v-app id="inspire" style="background: white;">

<div style="height: 200px; border-bottom: 1px #80808021 solid;" class="hidden-sm-and-down">
<v-layout row wrap style="padding: 40px; padding-bottom: 0px !important;">
  <v-flex md3 lg3 xl3 style="text-align: center;height: 200px;">
    <img src="https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_2.png" style="width: 150px;">
 </v-flex>
 <v-flex md4 lg4 xl4 style="height: 200px;">
    <h3>น้อง Wonder ชุด HNY</h3>
    <p><u>One Centric Company Limited</u></p>
    <span style="color: #00000091;">น้องวันเดอร์ มาสคอตประจำonechat ออกพิเศษในช่วงเทศกาลปีใหม่</span>
    <h1 style="color: #00b84f;">Free</h1>
 </v-flex>
</v-layout>
</div>

<div style="height: 200px; border-bottom: 1px #80808021 solid;"  class="hidden-md-and-up">
<v-layout row wrap style="padding: 10px; padding-bottom: 0px !important;">
  <v-flex xs4 sm4 style="text-align: center;height: 200px;">
    <img src="https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_2.png" style="width: 100px;">
 </v-flex>
 <v-flex xs8 sm8 style="height: 200px;">
    <h3>น้อง Wonder ชุด HNY</h3>
    <p><u>One Centric Company Limited</u></p>
    <span style="color: #00000091;">น้องวันเดอร์ มาสคอตประจำonechat ออกพิเศษในช่วงเทศกาลปีใหม่</span>
    <h1 style="color: #00b84f;">Free</h1>
 </v-flex>
</v-layout>
</div>

<div style="height: 100%; padding: 50px;" class="hidden-sm-and-down">
<v-layout row wrap style="">
  <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center; padding: 2px; " v-for="(item,index) in listSticker" class="listSticker" :key="index">
    <img :src="item.s3_name" style="width: 150px;">
    <div style="    border: 1px #899ab3 solid; border-radius: 10px; height: 60px;padding: 6px;margin-left: 10%;width: 80%;">
      <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="item.id">
            <v-icon style="color:#899ab3; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
      <span style="white-space: pre-line;word-wrap: break-word;color: #4c5665;">{{item.id}}</span>
    </div>
 </v-flex>
</v-layout>
</div>

<div style="height: 100%; padding: 5px;" class="hidden-md-and-up">
<v-layout row wrap style="">
  <v-flex xs12 sm12 style="text-align: center; padding: 2px; " v-for="(item,index_stic) in listSticker" class="listSticker" :key="index_stic">
    <img :src="item.s3_name" style="width: 150px;">
    <div style="    border: 1px #899ab3 solid; border-radius: 10px; height: 60px;padding: 6px; margin-left: 10%;width: 80%;">
      <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="item.id">
            <v-icon style="color:#899ab3; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
      <span style="white-space: pre-line;word-wrap: break-word;color: #4c5665;">{{item.id}}</span>
    </div>
 </v-flex>
</v-layout>
</div>

</v-app>
</template>

<script>
export default {
  data: () => ({
    listSticker: [
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_0',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_0.png'
      },
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_1',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_1.png'
      },
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_2',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_2.png'
      },
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_3',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_3.png'
      },
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_4',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_4.png'
      },
      {
        'id': 'Sec7aea7dd55f5150b51702bdeb2fa093_5',
        's3_name': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_5.png'
      }
    ]
  }),
  props: {
    source: String
  },
  methods: {
  },
  components: {
  },
  computed: {
  },
  watch: {
  },
  created () {
  }
}
</script>
<style type="text/css" scope>

.stickerlist {
  cursor: pointer;
}
.stickerlist:hover {
  background: aliceblue;
}
.requestmessage {
    display: none !important;
}

.listSticker:hover .requestmessage {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sticker/sticker_wonderHNY.vue